import type { ConversationSummary } from "../api/conversations";

export interface HistoryCache {
  conversations: ConversationSummary[];
  hasMore: boolean;
}

/**
 * Session-lifetime cache for the conversation history menu, so reopening it
 * (or navigating between views) doesn't refetch pages that are already loaded.
 * Cleared on sign out and whenever a new conversation is created.
 */
let cache: HistoryCache | null = null;

export function readHistoryCache(): HistoryCache | null {
  return cache;
}

export function writeHistoryCache(next: HistoryCache): void {
  cache = next;
}

export function invalidateHistoryCache(): void {
  cache = null;
}
